import { minValue, numeric, requiredUnless } from 'vuelidate/lib/validators';
import { QUOTA_SECTION_TITLE, SALARY_AND_SALES_PROCESS_SECTION_TITLE } from '../constants';
import { modalNames } from '@/components/partials/jobs/constants';
import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import getSdrQuotaConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/sdrQuotaConfig';
import getSdrQuotaFormConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/sdrQuotaFormConfig';
import getSdrSalaryConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/sdrSalaryConfig';
import getSdrSalaryFormConfig from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/configs/sdrSalaryFormConfig';
import type {
  JobsProfileConfig,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default (payload: JobsSectionModels): JobsProfileConfig => {
  return [
    {
      title: QUOTA_SECTION_TITLE,
      fields: [...getSdrQuotaConfig(payload)],
      editModalConfig: {
        name: modalNames.JOBS_EDIT_QUOTA,
        title: QUOTA_SECTION_TITLE,
        fields: [...getSdrQuotaFormConfig()],
        getValidation: ({ hasAdminPrivilege }) => ({
          sdrQuotaTypes: { required: requiredUnless(() => hasAdminPrivilege) },
          sdrQuotaPerPeriod: { required: requiredUnless(() => hasAdminPrivilege) },
          quotaAttainmentPerPeriod: { numeric },
          dealSize: {
            required: requiredUnless(() => hasAdminPrivilege),
          },
          quotaAttainmentPerLastYear: {
            required: requiredUnless(() => hasAdminPrivilege),
            numeric,
            greaterThanZero: hasAdminPrivilege ? () => true : minValue(1),
          },
        }),
        generateForm: utils.generateForm,
        prepareFormForUpsert: utils.prepareFormForUpsertForQuotaAndDealsModal,
      },
    },
    {
      title: SALARY_AND_SALES_PROCESS_SECTION_TITLE,
      fields: [...getSdrSalaryConfig(payload)],
      editModalConfig: {
        name: modalNames.JOBS_EDIT_SALARY,
        title: SALARY_AND_SALES_PROCESS_SECTION_TITLE,
        fields: [...getSdrSalaryFormConfig(payload)],
        getValidation: utils.validateEditSalarySectionModalForm,
        prepareFormForUpsert: utils.prepareFormForUpsert,
      },
    },
  ];
};
